import { HorseSelectedOutcome, PlayerCreateBetDTO, SelectedOutcome } from "@freeplay/shared-code";
import { GameState } from "../controllers/GameController";

export const createPlayerBetDTO = (state: GameState): PlayerCreateBetDTO => {
    const selectedOutcomeArray: Array<SelectedOutcome> = [];

    state.choices.forEach((value) => {
        const selectedOutcome: SelectedOutcome = {
            platformEventId: value.platformEventId,
            platformOfferId: value.platformOfferId,
            platformOutcomeId: value.platformOutcomeId,
        };

        selectedOutcomeArray.push(selectedOutcome);
    });

    const playerCreateBetDTO: PlayerCreateBetDTO = {
        betOutcomes: selectedOutcomeArray,
    };

    return playerCreateBetDTO;
};

export const createPlayerBetDTOWithHorseRacesPicks = (state: GameState): PlayerCreateBetDTO => {
    const selectedOutcomeArray: Array<HorseSelectedOutcome> = [];

    state.horseRaceChoices.forEach((value) => {
        const selectedOutcome: HorseSelectedOutcome = {
            choices: value.choices,
        };

        selectedOutcomeArray.push(selectedOutcome);
    });

    const playerCreateBetDTO: PlayerCreateBetDTO = {
        horseRaceOutcomes: selectedOutcomeArray,
    };

    return playerCreateBetDTO;
};
